// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a95c4709","186":"c1d8b3e5","272":"93d2e311","372":"84c0b7e2","377":"7b078151","443":"42c8ea0f","738":"af0506cb","841":"b1e9d12c","851":"9caa00fd","856":"8239cc10"}[chunkId] + ".chunk.js";
};